import { render, staticRenderFns } from "./_category.vue?vue&type=template&id=563166fb&scoped=true&"
import script from "./_category.vue?vue&type=script&lang=js&"
export * from "./_category.vue?vue&type=script&lang=js&"
import style0 from "./_category.vue?vue&type=style&index=0&id=563166fb&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563166fb",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/app/components/Header.vue').default,Button: require('/app/components/Button.vue').default,FooterV2: require('/app/components/FooterV2.vue').default})
